
export const linkRegex = /^https?:\/\/(?!gift-cards)[^/]+.express\.com(:\d+)?/;

export const isProductURLAbsolute = (productURL: string, productId: string) : boolean => {

  if (
    productId !== 'SVCP8' &&
    productURL !== '' &&
    productURL.substring(0, 4) !== 'http' &&
    (productURL.match(linkRegex) !== null || productURL.charAt(0) === '/')
  ) {
    return false;
  }

  return true;

}
